import { useState, useMemo } from 'react'
import {
  Box, Typography, Chip, TextField, InputAdornment,
  Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, TableSortLabel, Paper,
} from '@mui/material'
import { TrendingUp, Search } from '@mui/icons-material'
import ExportMenu from '../../components/common/ExportMenu'
import { formatNumber } from '../../utils/format'

const MONTH_KEYS = ['apr','may','jun','jul','aug','sep','oct','nov','dec','jan','feb','mar']
const MONTH_LABELS = ['Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec','Jan','Feb','Mar']

const DEMO_DATA = [
  { item: '10001', description: 'HV CHILI BNS 15oz', dc: 'Faribault', apr: 4200, may: 4400, jun: 3800, jul: 3500, aug: 3600, sep: 4000, oct: 5200, nov: 5800, dec: 5400, jan: 4800, feb: 4200, mar: 4000 },
  { item: '10001', description: 'HV CHILI BNS 15oz', dc: 'Dallas', apr: 2800, may: 3000, jun: 2600, jul: 2200, aug: 2400, sep: 2800, oct: 3600, nov: 4000, dec: 3800, jan: 3200, feb: 2800, mar: 2600 },
  { item: '10001', description: 'HV CHILI BNS 15oz', dc: 'Atlanta', apr: 1800, may: 2000, jun: 1600, jul: 1400, aug: 1500, sep: 1800, oct: 2400, nov: 2600, dec: 2400, jan: 2000, feb: 1800, mar: 1600 },
  { item: '10010', description: 'HV CHICKEN NOODLE 15oz', dc: 'Faribault', apr: 3600, may: 3800, jun: 3200, jul: 2800, aug: 3000, sep: 3400, oct: 4200, nov: 4600, dec: 4200, jan: 3800, feb: 3400, mar: 3200 },
  { item: '10010', description: 'HV CHICKEN NOODLE 15oz', dc: 'Dallas', apr: 2200, may: 2400, jun: 2000, jul: 1800, aug: 1900, sep: 2200, oct: 2800, nov: 3000, dec: 2800, jan: 2400, feb: 2200, mar: 2000 },
  { item: '10010', description: 'HV CHICKEN NOODLE 15oz', dc: 'Atlanta', apr: 1400, may: 1600, jun: 1200, jul: 1000, aug: 1100, sep: 1400, oct: 1800, nov: 2000, dec: 1800, jan: 1600, feb: 1400, mar: 1200 },
  { item: '10020', description: 'HV PORK & BEANS 15oz', dc: 'Faribault', apr: 3000, may: 3200, jun: 3400, jul: 3600, aug: 3800, sep: 3400, oct: 3000, nov: 2800, dec: 2600, jan: 2400, feb: 2600, mar: 2800 },
  { item: '10020', description: 'HV PORK & BEANS 15oz', dc: 'Dallas', apr: 1800, may: 2000, jun: 2200, jul: 2400, aug: 2600, sep: 2200, oct: 1800, nov: 1600, dec: 1500, jan: 1400, feb: 1500, mar: 1600 },
  { item: '10020', description: 'HV PORK & BEANS 15oz', dc: 'Atlanta', apr: 1200, may: 1400, jun: 1600, jul: 1800, aug: 2000, sep: 1600, oct: 1200, nov: 1000, dec: 900, jan: 800, feb: 900, mar: 1000 },
  { item: '10030', description: 'GMI PROGRESSO CHKN 19oz', dc: 'Faribault', apr: 2400, may: 2600, jun: 2200, jul: 2000, aug: 2100, sep: 2400, oct: 3000, nov: 3200, dec: 3000, jan: 2600, feb: 2400, mar: 2200 },
  { item: '10030', description: 'GMI PROGRESSO CHKN 19oz', dc: 'Dallas', apr: 1600, may: 1800, jun: 1400, jul: 1200, aug: 1300, sep: 1600, oct: 2000, nov: 2200, dec: 2000, jan: 1800, feb: 1600, mar: 1400 },
  { item: '10030', description: 'GMI PROGRESSO CHKN 19oz', dc: 'Atlanta', apr: 1000, may: 1200, jun: 900, jul: 800, aug: 900, sep: 1000, oct: 1400, nov: 1600, dec: 1400, jan: 1200, feb: 1000, mar: 900 },
  { item: '10011', description: 'HV TOMATO SOUP 10.75oz', dc: 'Faribault', apr: 3200, may: 3400, jun: 2800, jul: 2600, aug: 2800, sep: 3200, oct: 4000, nov: 4400, dec: 4000, jan: 3600, feb: 3200, mar: 3000 },
  { item: '10011', description: 'HV TOMATO SOUP 10.75oz', dc: 'Dallas', apr: 2000, may: 2200, jun: 1800, jul: 1600, aug: 1700, sep: 2000, oct: 2600, nov: 2800, dec: 2600, jan: 2200, feb: 2000, mar: 1800 },
  { item: '10011', description: 'HV TOMATO SOUP 10.75oz', dc: 'Atlanta', apr: 1200, may: 1400, jun: 1100, jul: 1000, aug: 1100, sep: 1200, oct: 1600, nov: 1800, dec: 1600, jan: 1400, feb: 1200, mar: 1100 },
]

export default function Demand() {
  const [search, setSearch] = useState('')
  const [orderBy, setOrderBy] = useState('item')
  const [order, setOrder] = useState('asc')

  const handleSort = (col) => {
    setOrder(orderBy === col && order === 'asc' ? 'desc' : 'asc')
    setOrderBy(col)
  }

  const rows = useMemo(() => {
    let filtered = DEMO_DATA.filter((r) =>
      `${r.item} ${r.description} ${r.dc}`.toLowerCase().includes(search.toLowerCase()),
    )
    filtered.sort((a, b) => {
      const av = a[orderBy], bv = b[orderBy]
      if (av == null || bv == null) return 0
      const cmp = typeof av === 'string' ? av.localeCompare(bv) : av - bv
      return order === 'asc' ? cmp : -cmp
    })
    return filtered
  }, [search, orderBy, order])

  return (
    <Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }}>
        <TrendingUp color="primary" />
        <Typography variant="h3" sx={{ flex: 1 }}>Demand</Typography>
        <ExportMenu />
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2, flexWrap: 'wrap' }}>
        <Chip label="New Horizons Forecast" size="small" variant="outlined" />
        <Typography variant="overline" color="text.secondary">
          As of Mar 10, 2026 · v8 · {DEMO_DATA.length} items
        </Typography>
      </Box>

      <TextField
        size="small"
        placeholder="Search items or DCs…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        sx={{ mb: 2, width: 280 }}
        slotProps={{ input: { startAdornment: <InputAdornment position="start"><Search fontSize="small" /></InputAdornment> } }}
      />

      <TableContainer component={Paper} variant="outlined" sx={{ overflowX: 'auto' }}>
        <Table size="small" sx={{ minWidth: 1200 }}>
          <TableHead>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>
                <TableSortLabel active={orderBy === 'item'} direction={orderBy === 'item' ? order : 'asc'} onClick={() => handleSort('item')}>Item #</TableSortLabel>
              </TableCell>
              <TableCell sx={{ fontWeight: 700 }}>
                <TableSortLabel active={orderBy === 'description'} direction={orderBy === 'description' ? order : 'asc'} onClick={() => handleSort('description')}>Description</TableSortLabel>
              </TableCell>
              <TableCell sx={{ fontWeight: 700 }}>
                <TableSortLabel active={orderBy === 'dc'} direction={orderBy === 'dc' ? order : 'asc'} onClick={() => handleSort('dc')}>DC</TableSortLabel>
              </TableCell>
              {MONTH_LABELS.map((m, i) => (
                <TableCell key={m} align="right" sx={{ fontWeight: 700 }}>
                  <TableSortLabel active={orderBy === MONTH_KEYS[i]} direction={orderBy === MONTH_KEYS[i] ? order : 'asc'} onClick={() => handleSort(MONTH_KEYS[i])}>{m}</TableSortLabel>
                </TableCell>
              ))}
              <TableCell align="right" sx={{ fontWeight: 700 }}>Total</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => {
              const total = MONTH_KEYS.reduce((s, k) => s + (row[k] || 0), 0)
              return (
                <TableRow key={`${row.item}-${row.dc}-${idx}`} hover>
                  <TableCell sx={{ fontWeight: 600 }}>{row.item}</TableCell>
                  <TableCell>{row.description}</TableCell>
                  <TableCell>{row.dc}</TableCell>
                  {MONTH_KEYS.map((k) => (
                    <TableCell key={k} align="right">{formatNumber(row[k])}</TableCell>
                  ))}
                  <TableCell align="right" sx={{ fontWeight: 700 }}>{formatNumber(total)}</TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
